import api from '@/services/api'

// Pasma górskie (hierarchia regionów) z GET /api/regions.
// Kontrakt: lista [{ id, name, level, parent_id }] (albo { regions: [...] }),
// a /api/ascents zwraca przy wejściu region_id szczytu (może być null).
// Uzupełnianie danych w BE trwa: brak endpointu, błąd albo pusta lista
// oznaczają "brak pasm", a szczyty trafiają do kategorii "bez pasma".
let regionsRequest = null

function normalize(payload) {
  const list = Array.isArray(payload) ? payload : (payload && Array.isArray(payload.regions) ? payload.regions : [])
  return list
    .filter(item => item && item.id !== null && item.id !== undefined && item.name)
    .map(item => {
      const parent = item.parent_id ?? item.parentId ?? null
      return { id: Number(item.id), name: String(item.name), level: item.level || null, parentId: parent === null ? null : Number(parent) }
    })
    .filter(item => Number.isFinite(item.id))
}

export function loadRegions() {
  if (!regionsRequest) {
    regionsRequest = api.get('/api/regions', { optional: true })
      .then(response => normalize(response.data))
      .catch(() => {
        regionsRequest = null // kolejne wejście na ekran spróbuje ponownie
        return []
      })
  }
  return regionsRequest
}

// Indeks hierarchii: id → { id, name, parentId, children }, odporny na
// rodzica spoza listy i na cykle (taki węzeł staje się korzeniem).
export function buildRegionIndex(regions = []) {
  const byId = new Map(regions.map(region => [region.id, { ...region, children: [] }]))

  const hasCycle = start => {
    const seen = new Set([start.id])
    let current = start
    while (current.parentId !== null && byId.has(current.parentId)) {
      if (seen.has(current.parentId)) return true
      seen.add(current.parentId)
      current = byId.get(current.parentId)
    }
    return false
  }

  byId.forEach(node => {
    if (node.parentId === null || !byId.has(node.parentId) || node.parentId === node.id || hasCycle(node)) {
      node.parentId = null
    }
  })
  byId.forEach(node => {
    if (node.parentId !== null) byId.get(node.parentId).children.push(node)
  })

  const roots = [...byId.values()].filter(node => node.parentId === null)
  return { byId, roots }
}

// Id regionu i wszystkich jego przodków (do filtrowania po węźle drzewa)
export function regionLineage(index, regionId) {
  const lineage = []
  let current = index.byId.get(regionId)
  while (current) {
    lineage.push(current.id)
    current = current.parentId === null ? null : index.byId.get(current.parentId)
  }
  return lineage
}

export const REGION_LEVEL_LABELS = {
  province: 'prowincja',
  subprovince: 'podprowincja',
  macroregion: 'makroregion',
  mesoregion: 'mezoregion'
}

// Drzewo spłaszczone do listy (np. <select>): rodzic przed dziećmi, alfabetycznie
export function flattenRegionTree(index) {
  const out = []
  const byName = (a, b) => a.name.localeCompare(b.name, 'pl')
  const walk = (node, depth) => {
    out.push({ id: node.id, name: node.name, level: node.level, depth })
    ;[...node.children].sort(byName).forEach(child => walk(child, depth + 1))
  }
  ;[...index.roots].sort(byName).forEach(root => walk(root, 0))
  return out
}
